export const VendorState={
  error: null,
  isFetching: false,
  shouldReload: false,

  vendorTypeData: [],

  vendorList: [],
  vendorTotal: 0,

  vendorDetail:{},

  stateOptions: [],

  simplyNexus: [],
  category:[],
  allVendor: {},

}
